import { useEffect, useState } from 'react';

import { useUserContext, useViewSize } from '@fff-web/fff-utilities';
import { Button } from '@fff-web/fff-ui-shared';

import { PICK_GIFT_AMOUNT_SECTION_ID } from '..';
import { getMembershipPrices } from '../../../services/gifting';
import fffWhite from '../assets/fabfitfun-white.svg';
import sparklesIcon from '../assets/sparkles.svg';
import * as styles from './header.module.scss';

export const PROMO_FEATURES = ['Instant digital delivery', 'Personalized'];

const Header = () => {
  const {
    userInfo: { loggedIn },
  } = useUserContext();
  const { isMobile } = useViewSize();
  const [prices, setPrices] = useState({ seasonalPrice: '', annualPrice: '' });

  const giftingPath = window.location.pathname.includes('gifting') ? '/gifting' : '';
  const loginURL = `${process.env.REACT_APP_LOGIN_URL}${window.location.href}`;
  const redeemGiftURL = `${giftingPath}/redeem-gift`;

  useEffect(() => {
    getMembershipPrices().then(setPrices);
  }, []);

  return (
    <header className={styles.container}>
      <div className={styles.cardContainer}>
        <div className={styles.fffCard}>
          <img src={fffWhite} alt="Fabfitfun gift card" />
        </div>
        <p>
          <span>Received a gift card?</span> <a href={redeemGiftURL}>Redeem it here</a>
        </p>
      </div>
      <div className={styles.row}>
        <h1 className={styles.title}>Give the Gift of FabFitFun</h1>
        <div className={styles.promoFeatures}>
          {PROMO_FEATURES.map((feature) => (
            <span key={feature} className={styles.feature}>
              <img src={sparklesIcon} alt="sparkles icon" />
              {feature}
            </span>
          ))}
        </div>
        <p className={styles.subtitle}>
          Up to $350 worth of premium, full-size products for just ${prices.seasonalPrice} per box -
          or gift a year of boxes ($1,400 value) for just ${prices.annualPrice}!
        </p>
        {loggedIn ? (
          <a className={styles.sendGiftLink} href={`#${PICK_GIFT_AMOUNT_SECTION_ID}`}>
            <Button containerFullWidth={isMobile}>Send a gift card</Button>
          </a>
        ) : (
          <div>
            <p>
              <strong>Existing FabFitFun Member?</strong>
            </p>
            <p>
              <a href={loginURL}>Login</a> to purchase a gift card.
            </p>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
